var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 250,
    viewBox: "0 0 1600 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3176_25013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1600,
    height: 250
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 250,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3176_25013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-194 55.4196L-132.12 71.0273C-71.6797 85.4343 52.0797 116.65 174.4 101.042C296.72 85.4343 420.48 24.2044 542.8 8.59671C665.12 -5.81034 788.88 24.2043 911.2 78.2308C1033.52 132.257 1157.28 176.36 1279.6 176.36C1401.92 176.36 1525.68 132.257 1586.12 93.8384L1648 55.4196V424H1586.12C1525.68 424 1401.92 424 1279.6 424C1157.28 424 1033.52 424 911.2 424C788.88 424 665.12 424 542.8 424C420.48 424 296.72 424 174.4 424C52.0797 424 -71.6797 424 -132.12 424H-194V55.4196Z",
    fill: "#500D76",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-104 90.4196L-27.8094 106.027C46.6094 120.434 198.991 151.65 349.6 136.042C500.209 120.434 652.591 59.2044 803.2 43.5967C953.809 29.1897 1106.19 59.2043 1256.8 113.231C1407.41 167.257 1559.79 211.36 1710.4 211.36C1861.01 211.36 2013.39 167.257 2087.81 128.838L2164 90.4196V459H2087.81C2013.39 459 1861.01 459 1710.4 459C1559.79 459 1407.41 459 1256.8 459C1106.19 459 953.809 459 803.2 459C652.591 459 500.209 459 349.6 459C198.991 459 46.6094 459 -27.8094 459H-104V90.4196Z",
    fill: "#500D76",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.55cf6f37ecb9923f55775f31afbd0415.svg";
export { ForwardRef as ReactComponent };